module.exports = __webpack_public_path__ + "img/picture_empty_default.bbdef240.png";